import React, { FC } from 'react'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { BidResponse } from 'apps/fleet-planner/types/apiTypes'

interface IBidByProps {
  bid: BidResponse
}

const useBidByStyles = makeStyles(() => ({
  coolGray6: {
    color: brandColors.coolGray6,
  },
  coolGray5: {
    color: brandColors.coolGray5,
  },
}))

export const BidBy: FC<IBidByProps> = ({ bid }) => {
  const classes = useBidByStyles()
  const { carrier, createdBy, status } = bid || {}
  const { name: carrierName = '' } = carrier || {}
  const { name: userName = '' } = createdBy || {}
  const className = status === 'declined' ? classes.coolGray5 : classes.coolGray6
  return (
    <Box>
      <Typography className={className} variant='subtitle1'>
        {carrierName}
      </Typography>
      <Typography className={className} variant='subtitle2'>
        {`Bid placed by ${userName}`}
      </Typography>
    </Box>
  )
}
